module.exports = __webpack_public_path__ + "img/about-1.4bf6517d.png";